import React, { useState, useEffect } from 'react';
import {
    Box,
    Flex,
    Text,
    Select,
    Td,
    Input,
    Stack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Spinner,
    Button,
    Checkbox,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
} from '@chakra-ui/react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import styles from '../Tabel.module.css';
import { ACCOUNTS_URL, BASE_URL } from '../../../../Globalapi/Globalapi';

const DaybookTable = ({ deleteItem }) => {
    const formatDate = (date) => date.toISOString().split('T')[0];

    const currentDate = formatDate(new Date());

    const [daybookData, setDaybookData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(12);
    const [fdate, setFdate] = useState(currentDate);
    const [tdate, setTdate] = useState(currentDate);
    const [selectedFdate, setSelectedFdate] = useState(currentDate);
    const [selectedTdate, setSelectedTdate] = useState(currentDate);
    const cmpId = sessionStorage.getItem('cmp_id');
    const [sortDirection, setSortDirection] = useState({ date: null, voucherNo: null, name: null });
    const [ctotal, setCtotal] = useState([]);
    const [dtotal, setDtotal] = useState([]);
    const [companyData, setCompanyData] = useState(null);
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchDaybookData = async () => {
            setLoading(true);
            try {
                const response = await axios.post(
                    `${ACCOUNTS_URL}/reports/load_daybook.php`,
                    { fdate: selectedFdate, tdate: selectedTdate, cmp_id: cmpId }
                );
                console.log('====================================');
                console.log(response);
                console.log('====================================');
                setDaybookData(response.data.daybookData || []);
                setCtotal(response.data.creditTotal || []);
                setDtotal(response.data.debitTotal || []);


            } catch (error) {
                console.error('Error fetching daybook data:', error);
            }
            setLoading(false);
        };

        if (selectedFdate && selectedTdate) {
            fetchDaybookData();
        }
    }, [selectedFdate, selectedTdate, cmpId]);

    const filteredDaybook = daybookData.filter(item =>
        item.L_name && item.L_name.toLowerCase().startsWith(searchTerm.toLowerCase())
    );

    const sortData = (data, field, direction) => {
        if (!field || !direction) return data;
        return [...data].sort((a, b) => {
            const valueA = a[field];
            const valueB = b[field];

            if (direction === 'asc') {
                return valueA > valueB ? 1 : -1;
            } else {
                return valueA < valueB ? 1 : -1;
            }
        });
    };

    const sortedData = sortData(filteredDaybook,
        sortDirection.date ? 'vouch_date' : sortDirection.voucherNo ? 'vouch_no' : sortDirection.name ? 'L_name' : null,
        sortDirection.date || sortDirection.voucherNo || sortDirection.name);

    const totalPages = Math.ceil(sortedData.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = sortedData.slice(indexOfFirstRow, indexOfLastRow);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const renderRow = (item, index) => (
        <Tr key={`${item.vouch_no}-${index}`}>
            <Td py="12px" px="20px" textAlign="center">
                <Checkbox />
            </Td>
            <Td py="12px" px="20px" textAlign="center">
                {item.vouch_date.split(" ")[0]}
            </Td>
            <Td py="12px" px="20px" textAlign="center">{item.vouch_no}</Td>
            <Td py="12px" px="20px">{item.L_name}</Td>
            <Td py="12px" px="20px" textAlign="center">{item.group_head_main}</Td>
            <Td py="12px" px="20px" textAlign="right">{item.debit_total} </Td>
            <Td py="12px" px="20px" textAlign="right">{item.credit_total} </Td>
        </Tr>
    );

    const handleSubmit = () => {
        setSelectedFdate(fdate);
        setSelectedTdate(tdate);
        setCurrentPage(1);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    useEffect(() => {
        const storedUserId = sessionStorage.getItem('cmp_id');
        if (storedUserId) {
            setUserId(storedUserId);
        } else {
            setError('User not logged in or user_id not found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const fetchCompanyDetails = async () => {
                try {
                    const response = await fetch(`${BASE_URL}/admin/Fees/fees_master/org_details.php`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ school_id: userId }),
                    });

                    const data = await response.json();

                    if (data.status === 200) {
                        setCompanyData(data.data);
                    } else {
                        setError('No company found for this user.');
                    }
                } catch (err) {
                    setError('Error fetching company details.');
                }
            };

            fetchCompanyDetails();
        }
    }, [userId]); // Run when userId is set

    const printVoucher = () => {
        // Detect if the user is on a mobile device
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        // Create the content for printing
        const printContent = `
            <html>
                <head>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                            .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                .header h2 { margin: 0; font-size: 24px; }
                .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
                        
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
              <div class="header">
    ${companyData.s_name && companyData.s_name.startsWith("No") === false
                ? `<h2>${companyData.s_name}</h2>`
                : ""}
    ${companyData.s_address && companyData.s_address.startsWith("No") === false
                ? `<p>${companyData.s_address}</p>`
                : ""}
    ${companyData.s_address && companyData.s_address.startsWith("No") === false
                ? `<p>GSTIN/UIN: ${companyData.s_address}</p>`
                : ""}
    ${companyData.s_email && companyData.s_email.startsWith("No") === false
                ? `<p>Email: ${companyData.s_email}</p>`
                : ""}
</div>
                    <table>
                        <thead>
                            <tr style="background-color: #0073e6; color: white;">
                                <th style="text-align: center; padding: 12px;">Date</th>
                                <th style="text-align: center; padding: 12px;">Voucher No.</th>
                                <th style="padding: 12px;">Particulars</th>
                                <th style="text-align: center; padding: 12px;">Type</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${daybookData.map((item, index) => {
                    const isBold = item.sho_name_1 === "Opening Balance" || item.sho_name_1 === "Current Total";
                    return `
                                    <tr style="font-weight: ${isBold ? 'bold' : 'normal'};">
                                        <td style="padding: 12px 20px; text-align: center;">${item.vouch_date.split(" ")[0]}</td>
                                        <td style="padding: 12px 20px; text-align: center;">${item.vouch_no}</td>
                                        <td style="padding: 12px 20px; text-align: center;">${item.L_name}</td>
                                        <td style="padding: 12px 20px; text-align: center;">${item.group_head_main}</td>
                                        <td style="padding: 12px 20px; text-align: right;">${item.debit_total}</td>
                                        <td style="padding: 12px 20px; text-align: right;">${item.credit_total}</td>
                                    </tr>
                                `;
                }).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

        // Check if it's a mobile device
        if (isMobile) {
            // For mobile devices, open a new window and write the content for printing
            const printWindow = window.open('', '_blank');
            printWindow.document.open();
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.print();
        } else {
            // For desktop, use an iframe for printing
            const iframe = document.createElement('iframe');
            document.body.appendChild(iframe);

            // Ensure the iframe is not visible
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = 'none';

            // Access the iframe's document for writing content
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(printContent);
            iframeDoc.close();

            // Print from the iframe and remove it afterward
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        }
    };

    return (
        <Box
            // borderWidth="1px" 
           minH="750px" w='100%' maxW="100%" 
            //  bg='white'
            p={1}
            overflowX="auto">
            <Flex
                // borderTopWidth="1px"
                p={3}
                direction={{ base: "column", md: "row" }}
                justify="space-between"
                className='sb'
                // borderRadius="20px"
            >
                {/* Rows Per Page - Left align on mobile */}
                <Flex align="center" mb={{ base: 4, md: 0 }} p={1} justify={{ base: "flex-start", md: "center" }}>
                    <Text mr={2}>Rows Per Page</Text>
                    <Select
                        width="100px"
                        value={rowsPerPage}
                        onChange={(e) => {
                            setRowsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        borderColor="#E9EDF4"
                    >
                        <option value={12}>12</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </Select>
                    <Text ml={2}>Entries</Text>
                </Flex>

                {/* Date Inputs and Submit Button */}
                <Flex
                    justify={{ base: "space-between", md: "flex-end" }}
                    align="start"
                    direction={{ base: "column", md: "row" }}
                >
                    <Flex
                        direction={{ base: "column", md: "row" }}
                        align="flex-start"
                        spacing={4}
                        mb={{ base: 4, md: 0 }}
                        w={{ base: '100%' }}
                    >
                        <Input
                            type="date"
                            placeholder="From Date"
                            value={fdate}
                            borderColor="#E9EDF4"
                            onChange={(e) => setFdate(e.target.value)}
                            mb={{ base: 2, md: 0 }}
                            mr={{ base: 0, md: 4 }}
                            w={{ base: '100%', md: 'auto' }}
                        />
                        <Input
                            type="date"
                            placeholder="To Date"
                            value={tdate}
                            borderColor="#E9EDF4"
                            onChange={(e) => setTdate(e.target.value)}
                            w={{ base: '100%', md: 'auto' }}
                        />
                    </Flex>
                    <Button
                        backgroundColor="teal"
                        ml={{ base: 0, md: 4 }}
                        color="white"
                        onClick={handleSubmit}
                        alignSelf={{ base: "flex-start", md: "center" }}
                        w={{ base: '100%', md: 'auto' }}
                    >
                        Submit
                    </Button>
                    <Button
                        onClick={printVoucher}
                        w={{ base: '100%', md: 'auto' }}
                        mt={{ base: 2, md: 0 }}
                        ml={{ md: 4 }}
                        minW={{ md: '70px' }}  // Minimum width for desktop to avoid shrinking
                    >
                        Print
                    </Button>
                </Flex>

            </Flex>


            <Box overflowX="auto" w={{ base: '367px', md: '100%' }} className={styles.Table}>

                {loading ? (
                    <Spinner size="xl" />
                ) : (
                    <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} borderWidth='1px'>
                        <Thead>
                            <Tr>
                                <Th textAlign="center" textTransform="none" fontFamily="'Poppins', sans-serif">
                                    <Checkbox />
                                </Th>
                                <Th textTransform="none" textAlign="center" fontFamily="'Poppins', sans-serif"
                                    position="relative"
                                    _hover={{ ".filter-icon": { display: 'inline-block' } }}>
                                    Date
                                    <Box
                                        as="span"
                                        display="none"
                                        className="filter-icon"
                                        position="absolute"
                                        right={0}
                                        top="50%"
                                        transform="translateY(-50%)"
                                    >
                                        <Menu>
                                            <MenuButton as={Button} variant="link" textDecoration="none">
                                                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                                            </MenuButton>
                                            <MenuList>
                                                <MenuItem onClick={() => setSortDirection({ date: 'asc', voucherNo: null, name: null })}>Ascending</MenuItem>
                                                <MenuItem onClick={() => setSortDirection({ date: 'desc', voucherNo: null, name: null })}>Descending</MenuItem>
                                            </MenuList>
                                        </Menu>
                                    </Box>
                                </Th>
                                <Th textTransform="none" textAlign="center" fontFamily="'Poppins', sans-serif"
                                    position="relative"
                                    _hover={{ ".filter-icon": { display: 'inline-block' } }}>
                                    Voucher No
                                    <Box
                                        as="span"
                                        display="none"
                                        className="filter-icon"
                                        position="absolute"
                                        right={0}
                                        top="50%"
                                        transform="translateY(-50%)"
                                    >
                                        <Menu>
                                            <MenuButton as={Button} variant="link" textDecoration="none">
                                                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                                            </MenuButton>
                                            <MenuList>
                                                <MenuItem onClick={() => setSortDirection({ voucherNo: 'asc', date: null, name: null })}>
                                                    Ascending
                                                </MenuItem>
                                                <MenuItem onClick={() => setSortDirection({ voucherNo: 'desc', date: null, name: null })}>
                                                    Descending
                                                </MenuItem>
                                            </MenuList>
                                        </Menu>
                                    </Box>
                                </Th>
                                <Th
                                    textTransform="none"
                                    fontFamily="'Poppins', sans-serif"
                                    position="relative"
                                    _hover={{ ".filter-icon": { display: 'inline-block' } }}
                                >
                                    Particulars
                                    <Box
                                        as="span"
                                        display="none"
                                        className="filter-icon"
                                        position="absolute"
                                        right={0}
                                        top="50%"
                                        transform="translateY(-50%)"
                                    >
                                        <Menu>
                                            <MenuButton as={Button} variant="link" textDecoration="none">
                                                <FontAwesomeIcon icon={faFilter} style={{ marginRight: '5px' }} />
                                            </MenuButton>
                                            <MenuList>
                                                <MenuItem onClick={() => setSortDirection({ name: 'asc', date: null, voucherNo: null })}>Ascending</MenuItem>
                                                <MenuItem onClick={() => setSortDirection({ name: 'desc', date: null, voucherNo: null })}>Descending</MenuItem>
                                            </MenuList>
                                        </Menu>
                                    </Box>
                                </Th>
                                <Th textAlign="center" textTransform="none" fontFamily="'Poppins', sans-serif">Type</Th>
                                <Th textAlign="right" textTransform="none" fontFamily="'Poppins', sans-serif">Debit</Th>
                                <Th textAlign="right" textTransform="none" fontFamily="'Poppins', sans-serif">Credit</Th>
                            </Tr>
                        </Thead>
                        <Tbody>{currentData.map(renderRow)}</Tbody>
                    </Table>
                )}
            </Box>

            <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
                <Tbody>
                    <Tr >
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="right"></Td>
                        <Td py="12px" px="12px" textAlign="right"></Td>
                        <Td py="12px" px="20px" textAlign="left" fontWeight="bold">Current Total</Td>
                        {/* <Td py="12px" px="20px" textAlign="right"></Td> */}
                        {/* <Td py="12px" px="30px" textAlign="right"></Td> */}
                        <Td py="12px" px="15px" textAlign="right" fontWeight="bold">{dtotal} Dr</Td>
                        <Td py="12px" px="6px" textAlign="right" fontWeight="bold">{ctotal} Cr</Td>

                    </Tr>
                </Tbody>

            </Table>
            {currentData.length > 0 && (
                <Flex justify="end" className='sb2' borderTopWidth="1px" mt={1} p={3}>
                    <Button onClick={() => handlePageChange(currentPage - 1)} isDisabled={currentPage === 1}>
                        Prev
                    </Button>
                    <Stack direction="row" mx={2}>
                        {currentPage > 1 && (
                            <>
                                <Button onClick={() => handlePageChange(1)}>1</Button>
                                {currentPage > 2 && <Text>...</Text>}
                            </>
                        )}
                        <Button backgroundColor='teal' color="white">{currentPage}</Button>
                        {currentPage < totalPages - 1 && (
                            <>
                                <Text>...</Text>
                                <Button onClick={() => handlePageChange(totalPages)}>{totalPages}</Button>
                            </>
                        )}
                    </Stack>
                    <Button onClick={() => handlePageChange(currentPage + 1)} isDisabled={currentPage === totalPages}>
                        Next
                    </Button>
                </Flex>
            )}
        </Box>
    );
};

export default DaybookTable;
